import { useEffect, useRef } from 'react';
import qrcode from 'qrcode-generator';

interface QRCodeDisplayProps {
  url: string;
  size?: number;
  className?: string;
}

export const QRCodeDisplay = ({ url, size = 128, className }: QRCodeDisplayProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!url || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    if (!ctx) return;

    try {
      // Create QR code
      const qr = qrcode(0, 'M'); // Type number 0 (auto), error correction level M
      qr.addData(url);
      qr.make();

      // Get the module count (size of the QR code matrix)
      const moduleCount = qr.getModuleCount();
      const cellSize = Math.floor(size / moduleCount);
      const qrSize = cellSize * moduleCount;

      // Set canvas dimensions
      canvas.width = qrSize;
      canvas.height = qrSize;

      // Clear canvas
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, qrSize, qrSize);

      // Draw QR code modules
      ctx.fillStyle = '#000000';
      for (let row = 0; row < moduleCount; row++) {
        for (let col = 0; col < moduleCount; col++) {
          if (qr.isDark(row, col)) {
            ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
          }
        }
      }
    } catch (error) {
      console.error('Error generating QR code:', error);
      
      // Draw error placeholder
      ctx.fillStyle = '#F3F4F6';
      ctx.fillRect(0, 0, size, size);
      ctx.fillStyle = '#6B7280';
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('QR Error', size / 2, size / 2);
    }
  }, [url, size]);

  return (
    <div className={`${className}`}>
      <canvas
        ref={canvasRef}
        className="border border-gray-200 rounded"
        style={{ width: size, height: size }}
      />
    </div>
  );
};
